var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoTasks = function SvgNoTasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 151,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M38.255 64.37s-24.31 54.889 39.695 55.659 93.26-7.66 93.55-35.6-22.76-54-62.94-54.295S46.655 40.37 38.255 64.37",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M125.055 130.534v-21.995l21.995-1.965 3.93 23.96z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "m120.97 97.325 5.46 7.68v3.415l19.24-1.72-.975-9.376s2.355-11.17-.59-18.44a25.6 25.6 0 0 1-1.705-10.59c.145-3.325-4.635-4.09-5.5-.87a31 31 0 0 0-.58 6.945 8 8 0 0 1-.72 3.41c-1.175 2.596-3.135 7.69-1.96 10.546l-2.265 11.14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m131.375 99.44 1.945 8.364-6.89.615v-3.415l-5.46-7.68z",
    opacity: 0.09
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M59.33 40.92s-4.45 1-5.075-4.45 0-7.5 0-7.5H64.72s5.31 13.124-5.39 11.95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M59.33 40.92s-4.45 1-5.075-4.45 0-7.5 0-7.5H64.72s5.31 13.124-5.39 11.95",
    opacity: 0.08
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M67.18 22.5s-3.63-.09-4.45 5.065 1.17 12.3-3.4 13.355h12.765s7.855-18.1-4.915-18.42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M75.15 22.5h-7.97a8.59 8.59 0 0 1 4.915 6.94v68.12a8.213 8.213 0 0 0 8.215 8.215h48.29a8.2 8.2 0 0 0 5.807-2.407 8.2 8.2 0 0 0 2.403-5.808v-66a9.05 9.05 0 0 0-9.055-9.05z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M105.94 52.74s8 13.5-2.545 23.884-23.65 6.3-23.65 6.3l-6.605 16.82-4.81-5.93 5.33-14.295 3.69-7.745 15-6.41z",
    opacity: 0.08
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.365 36.305h29.215a4.453 4.453 0 0 1 4.455 4.455v32.15a4.453 4.453 0 0 1-4.455 4.455H92.365z",
    opacity: 0.35
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "m78.095 73.838-5.366-3.146-5.98 10.201 5.366 3.146z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m78.095 73.838-5.366-3.146-5.98 10.201 5.366 3.146z",
    opacity: 0.29
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M84.66 78.1c11.935 0 21.61-9.676 21.61-21.61 0-11.936-9.675-21.61-21.61-21.61s-21.61 9.674-21.61 21.61c0 11.934 9.675 21.61 21.61 21.61"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.66 71.77c8.439 0 15.28-6.842 15.28-15.28 0-8.44-6.841-15.28-15.28-15.28s-15.28 6.84-15.28 15.28c0 8.438 6.841 15.28 15.28 15.28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "m73.112 82.144-5.253-3.08a2.555 2.555 0 0 0-3.497.912L54.346 97.06a2.556 2.556 0 0 0 .912 3.497l5.254 3.079a2.554 2.554 0 0 0 3.496-.912L74.024 85.64a2.555 2.555 0 0 0-.912-3.496"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M51.745 96.045a16.09 16.09 0 0 1 6.675-11.82 12.57 12.57 0 0 1 8.76-2.325c9.84 1.1 7.8 15.92 3 24.345S58.315 115.77 54 111.37c-2.82-2.87-2.695-10.36-2.255-15.325"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "m49.605 104.54-4.085 25.995h23.855l.825-22.25z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M83.945 63.12a1.23 1.23 0 0 1-.975-.47l-4.205-5.256a1.248 1.248 0 0 1 .63-1.981 1.25 1.25 0 0 1 1.325.421l3.095 3.87 4.72-7.62A1.249 1.249 0 1 1 90.66 53.4L85 62.53a1.26 1.26 0 0 1-1 .59zM126.035 85.475H84.66V96.03h41.375zM148.06 17.05h-35.745v25.104h35.745z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M125.8 31.714h-5.12v3.395h5.12zM133.1 28.21h-5.12v6.9h5.12zM140.245 23.685h-5.12v11.43h5.12z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.23 34.93h-23.065v1.475h23.065z"
  })));
};
export default SvgNoTasks;